import { createFeatureSelector, createSelector } from '@ngrx/store';
import { GET_ORDER_LIST_STORE_NAME, GetOrderListState } from './get-order-list.state';

/** Select GetOrderList State */
export const selectGetOrderListState = createFeatureSelector<GetOrderListState>(GET_ORDER_LIST_STORE_NAME);

/** Select GetOrderList isPending status */
export const selectGetOrderListIsPendingStatus = createSelector(selectGetOrderListState, (state) => !!state.isPending);

/** Select GetOrderList isFailure status */
export const selectGetOrderListIsFailureStatus = createSelector(selectGetOrderListState, (state) => !!state.isFailure);
